import {
  SET_ROLE_LIST, SET_RESET_USER, SET_RESET_USER_LIST, SET_SEARCH_USER_ID,
  SET_SEARCH_USER_NAME, SET_SEARCH_ROLE,
  SET_SORT_ITEM, SET_SORT_ORDER, SET_NOW_PAGE, SET_USER_RESULT_LIST,
  SET_UPDATE_USER_ID, SET_UPDATE_USER_NAME, SET_UPDATE_ROLE_LIST,
  SET_UPDATE_DATE,
  SET_MODIFY_POP_FLG,
  SET_INIT_USER_MANAGED_STATE, SET_ERR_MODIFY_POP_MESSAGE,
  SET_PASSWORD_RESET_POP_FLG, SET_PASSWORD_RESET_POP_MESSAGE,
} from '../actions/UserManagedAction';
import { SORT_ORDER } from '../../common/const';

const initState = {
  // 権限リスト
  roleList: null,
  // パスワードリセット対象者リスト
  resetUserList: null,
  // 検索条件のユーザーID
  searchUserId: null,
  // 検索条件のユーザー名
  searchUserName: null,
  // 検索条件の権限
  searchRole: null,
  // 検索条件のソート項目
  sortItem: null,
  // 検索条件のソート順序
  sortOrder: SORT_ORDER.ASC,
  // 現在のページ
  nowPage: null,
  // 検索結果
  userResultList: null,
  // 更新対象ユーザーID
  updateUserId: null,
  // 新規ユーザー名
  updateUserName: null,
  // 更新対象ユーザーの権限リスト
  updateRoleList: null,
  // 更新日時
  updateDate: null,
  // ユーザー情報変更POPUP表示フラグ
  modifyPopFlg: false,
  // ユーザー情報変更POPUP表示メッセージ
  errModifyPopMessage: null,
  // パスワードリセットPOPUP表示フラグ
  passwordResetPopFlg: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case SET_ROLE_LIST:
      return { ...state, roleList: action.roleList };
    case SET_RESET_USER:
    {
      const idx = state.resetUserList.indexOf(action.resetUser);
      const regFlag = !(idx >= 0);
      let resetUserList = regFlag ? [action.resetUseFr] : [];
      if (state.resetUserList && state.resetUserList.length > 0) {
        resetUserList = state.resetUserList.concat(resetUserList);
        if (!regFlag) resetUserList.splice(idx, 1);
      }
      return { ...state, resetUserList };
    }
    case SET_RESET_USER_LIST:
      return { ...state, resetUserList: action.resetUserList };
    case SET_SEARCH_USER_ID:
      return { ...state, searchUserId: action.searchUserId };
    case SET_SEARCH_USER_NAME:
      return { ...state, searchUserName: action.searchUserName };
    case SET_SEARCH_ROLE:
      return { ...state, searchRole: action.searchRole };
    case SET_SORT_ITEM:
      return { ...state, sortItem: action.sortItem };
    case SET_SORT_ORDER:
      return { ...state, sortOrder: action.sortOrder };
    case SET_NOW_PAGE:
      return { ...state, nowPage: action.nowPage };
    case SET_USER_RESULT_LIST:
      return { ...state, userResultList: action.userResultList };
    case SET_UPDATE_USER_ID:
      return { ...state, updateUserId: action.updateUserId };
    case SET_UPDATE_USER_NAME:
      return { ...state, updateUserName: action.updateUserName };
    case SET_UPDATE_ROLE_LIST:
      return { ...state, updateRoleList: action.updateRoleList };
    case SET_UPDATE_DATE:
      return { ...state, updateDate: action.updateDate };
    case SET_MODIFY_POP_FLG:
      return { ...state, modifyPopFlg: action.modifyPopFlg };
    case SET_ERR_MODIFY_POP_MESSAGE:
      return { ...state, errModifyPopMessage: action.errModifyPopMessage };
    case SET_PASSWORD_RESET_POP_FLG:
      return { ...state, passwordResetPopFlg: action.passwordResetPopFlg };
    case SET_PASSWORD_RESET_POP_MESSAGE:
      return { ...state, errModifyPopMessage: action.passwordResetPopMessage };
    case SET_INIT_USER_MANAGED_STATE:
      return { ...initState };
    default:
      return state;
  }
};
